import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

// Connects to data-controller="lead-flow-filters"
export default class extends Controller {
  static targets = ["leadClass", "leadQuality", "timezone", "apply", "cardValue"]

  connect() {
    // Store the user's default timezone from the initially selected value
    this.defaultTimezone = this.hasTimezoneTarget ? this.timezoneTarget.value : "Eastern Time (US & Canada)";
  }

  applyFilters(event) {
    event?.preventDefault();

    const leadClass = this.hasLeadClassTarget ? this.leadClassTarget.value : "";
    const leadQuality = this.hasLeadQualityTarget ? this.leadQualityTarget.value : "";
    const timezone = this.hasTimezoneTarget ? this.timezoneTarget.value : this.defaultTimezone;

    post("/admin/lead_flow_reports/filter_counts", {
      body: JSON.stringify({
        lead_flow: {
          lead_class: leadClass,
          lead_quality: leadQuality,
          timezone: timezone
        }
      }),
      contentType: "application/json"
    })
      .then(async response => {
        const data = await response.json;
        if (data && data.counts) {
          this.updateCardValues(data.counts);
        }
      })
      .catch(error => {
        console.error("Error applying filters:", error);
      });
  }

  clearFilters(event) {
    event?.preventDefault();

    if (this.hasLeadClassTarget) {
      this.leadClassTarget.value = "MortgageProtectionLead";
    }
    if (this.hasLeadQualityTarget) {
      this.leadQualityTarget.value = "";
    }
    if (this.hasTimezoneTarget) {
      this.timezoneTarget.value = this.defaultTimezone;
    }

    this.applyFilters(event);
    document.dispatchEvent(new CustomEvent("filters:cleared"));
  }

  updateCardValues(counts) {
    // Each card value/sub-value span carries data-count-key (emitted by the
    // shared/stat_cards partial), so values map by key — no coupling to DOM order.
    this.cardValueTargets.forEach((target) => {
      const key = target.dataset.countKey;
      if (key && counts[key] !== undefined) {
        target.textContent = counts[key];
      }
    });
  }

}
